<template lang="pug">
    .googlemap

        h3.googlemap__title
            span(v-html="title")

        p.googlemap__desc Нажмите на регион чтобы узнать больше

        //- .googlemap-switch
        //-     input.googlemap-switch__radio(
        //-         type='radio',
        //-         id='cities',
        //-         name='googlemap__switch',
        //-         value='cities',
        //-         v-model='mapSwitch'
        //-         )
        //-     label.googlemap-switch__label(
        //-         for='cities'
        //-         ) Города

        //-     input.googlemap-switch__radio(
        //-         type='radio',
        //-         id='regions',
        //-         name='googlemap__switch',
        //-         value='regions'
        //-         v-model='mapSwitch'
        //-         )
        //-     label.googlemap-switch__label(
        //-         for='regions'
        //-         ) Регионы

        .googlemap__wrapper

            .googlemap__container(ref='mapContainer')

            .googlemap-infobox(
                v-if='infoboxName'
                )

                button.googlemap-infobox__close(
                    type='button',
                    aria-label='Закрыть',
                    @click.prevent='clickCloseInfobox'
                    )
                    svg(
                        xmlns='http://www.w3.org/2000/svg',
                        viewBox='0 0 23 23',
                        width='23',
                        height='23'
                        )
                        path(fill='#efdb34', d='M0 0h23v23H0z')
                        path(d='M17.93 18.11H15l-3.5-5.64L8 18.11H5.07l4.28-6.58L5.61 6h2.92l3 4.6L14.59 6h2.88l-3.76 5.54z')

                h3.googlemap-infobox__name(
                    v-html='infoboxName'
                    )

                p.googlemap-infobox__empty(
                    v-if='infobox.cost.value === 0'
                    ) Нет данных

                ul.googlemap-infobox__list(
                    v-if='infobox.cost.value !== 0'
                    )

                    li.googlemap-infobox__item(
                        v-for='(infoboxValue, infoboxKey) in infobox',
                        :key='infoboxKey'
                        )

                        .googlemap-infobox__icon
                            svg.googlemap-infobox__svg(
                                v-if='infoboxKey === "cost"'
                                xmlns='http://www.w3.org/2000/svg',
                                viewBox='0 0 61.07 50.22',
                                width='61',
                                height='50'
                                )
                                path(d='M46.49 7.79a29.44 29.44 0 0 0-8.26 1.08v-.53c0-4.68-8.4-8.34-19.12-8.34S0 3.66 0 8.34v33.54c0 4.68 8.4 8.34 19.11 8.34s19.12-3.66 19.12-8.34v-1.56a29.44 29.44 0 0 0 8.26 1.08c8.32 0 14.58-2.79 14.58-6.5V14.29c0-3.71-6.26-6.5-14.58-6.5zm-10.21 28a38.59 38.59 0 0 1-17 3.74A40.59 40.59 0 0 1 2 35.74v-6.09a42.69 42.69 0 0 0 17.29 3.54 44.25 44.25 0 0 0 6.24-.44V35a1 1 0 0 0 1.94 0v-2.57q.76-.13 1.47-.3v2.12a1 1 0 0 0 1.95 0v-2.61c.56-.15 1.09-.31 1.58-.47V33a1 1 0 1 0 1.95 0v-2.51c.75-.3 1.4-.57 1.91-.81zm-9.83-16.16a1 1 0 0 0 1-1V16v-.13c.51-.11 1-.22 1.49-.35v2.34a1 1 0 0 0 1.95 0v-2.64a.93.93 0 0 0-.05-.24c.57-.19 1.12-.39 1.63-.61v1.69a1 1 0 0 0 1.95 0v-2.65a11.53 11.53 0 0 0 1.91-1.36v7.21a38.59 38.59 0 0 1-17 3.74A40.59 40.59 0 0 1 2 19.25v-7.2c3.07 2.76 9.52 4.63 17.16 4.63a44.17 44.17 0 0 0 6.37-.46v2.44a1 1 0 0 0 .92.97zm9.83 7.88a38.46 38.46 0 0 1-17 3.74A40.59 40.59 0 0 1 2 27.5v-6.09A42.86 42.86 0 0 0 19.24 25a44.25 44.25 0 0 0 6.24-.44v2.16a1 1 0 1 0 1.94 0v-2.53c.51-.1 1-.2 1.47-.31v2a1 1 0 1 0 1.95 0V23.4c.56-.16 1.09-.31 1.58-.47v1.66a1 1 0 0 0 1.95 0v-2.35c.75-.29 1.4-.57 1.91-.81zM19.11 2c10.12 0 17.17 3.32 17.17 6.34s-7 6.4-17.17 6.4S2 11.36 2 8.34 9 2 19.11 2zm0 46.33C9 48.28 2 44.91 2 41.88v-4a42.86 42.86 0 0 0 17.29 3.54 44.25 44.25 0 0 0 6.19-.42v2.37a1 1 0 1 0 1.94 0v-2.64l1.48-.3v2.2a1 1 0 1 0 1.95 0v-2.69c.56-.15 1.09-.31 1.59-.47v1.87a1 1 0 0 0 1.95 0v-2.61c.75-.29 1.4-.57 1.91-.81v4c-.02 2.99-7.07 6.36-17.19 6.36zm40-13.38c0 2.15-5.41 4.56-12.64 4.56a26.59 26.59 0 0 1-8.26-1.21v-5a33.14 33.14 0 0 0 8.36 1.06c1 0 1.87 0 2.74-.11V36a1 1 0 0 0 2 0v-2q.77-.1 1.47-.24v1.63a1 1 0 0 0 2 0v-2a27.68 27.68 0 0 0 4.43-1.51zm0-5.24a28.89 28.89 0 0 1-12.54 2.7 31.38 31.38 0 0 1-8.36-1.13v-4.67a33.64 33.64 0 0 0 8.36 1.05c1 0 1.87 0 2.74-.11v2a1 1 0 0 0 2 0v-2.22q.77-.1 1.47-.24v1.77a1 1 0 0 0 2 0v-2.19a28 28 0 0 0 4.43-1.51zm0-6.65a28.85 28.85 0 0 1-12.54 2.71 31.8 31.8 0 0 1-8.36-1.13v-4.9a29.35 29.35 0 0 0 8.26 1.1c1 0 1.93 0 2.84-.12v2.44a1 1 0 0 0 2 0v-2.71c.5-.07 1-.16 1.47-.25v2.26a1 1 0 0 0 2 0v-2.71a13.4 13.4 0 0 0 4.44-2.1zm-12.62-4.22a26.92 26.92 0 0 1-8.26-1.2v-6.7a26.92 26.92 0 0 1 8.26-1.2c7.23 0 12.64 2.4 12.64 4.55s-5.41 4.55-12.64 4.55z')
                                path(d='M21.52 9.48c3.91 0 5.52-1.22 3.58-2.71s-6.73-2.7-10.7-2.7a13.78 13.78 0 0 0-2.49.2c-.52.1-.47.4.08.67l6.6 5h-.71c-.72 0-1 .24-.58.55a4 4 0 0 0 2 .54h.7l1.07.81a4 4 0 0 0 2 .54c.72 0 1-.24.58-.55l-1-.83h2.83c.72 0 1-.25.59-.55a4 4 0 0 0-2-.54h-2.86l-.6-.45zm.94-2.71c1.16.89.1 1.62-2.38 1.62h-.92L15 5.19h.85c2.48-.03 5.45.69 6.61 1.58z')

                            svg.googlemap-infobox__svg(
                                v-if='infoboxKey === "porsche"'
                                xmlns='http://www.w3.org/2000/svg',
                                viewBox='0 0 64.31 26.31',
                                width='64',
                                height='26'
                                )
                                path(d='M62.89 13.13L61.18 12l-1.29-3.59a1.66 1.66 0 0 0-1.46-1.1l-18-1.18-5.3-3.73A11.49 11.49 0 0 0 25.87.62l-3.93.93A45.13 45.13 0 0 0 10 6.3H5.32L3.8 4.78a1.65 1.65 0 0 0-2.36 0 1.67 1.67 0 0 0 0 2.36l2 2a1.7 1.7 0 0 0 1.18.49h.32C4 10.37 3 11.16 2.11 12a1.68 1.68 0 0 0-.55 1.24v1.36L.49 16.78a1.59 1.59 0 0 0-.18.74 3.76 3.76 0 0 0 3.76 3.75h6a6.39 6.39 0 0 0 12.34 0h20.66a6.39 6.39 0 0 0 12.34 0h4.14a3.77 3.77 0 0 0 3.62-2.74l.74-2.63a2.53 2.53 0 0 0-1-2.77zM60 17.63a.43.43 0 0 1-.41.3h-4.18a6.39 6.39 0 0 0-12.34 0H22.46a6.39 6.39 0 0 0-12.34 0h-6a.46.46 0 0 1-.35-.17l1-2A1.71 1.71 0 0 0 4.9 15v-1a41.92 41.92 0 0 1 17.81-9.2l3.93-.93a8.14 8.14 0 0 1 6.57 1.26l5.71 4a1.62 1.62 0 0 0 .85.3l17.35 1.14 1.11 3.06a1.62 1.62 0 0 0 .64.82l1.66 1.12zm-7.67 2a3.05 3.05 0 1 1-3-3.05 3.06 3.06 0 0 1 3 3.05zm-32.95 0a3.06 3.06 0 1 1-3.05-3.05 3.06 3.06 0 0 1 3.05 3.05z')

                            svg.googlemap-infobox__svg(
                                v-if='infoboxKey === "iphone"'
                                xmlns='http://www.w3.org/2000/svg',
                                viewBox='0 0 29.09 51.52',
                                width='29',
                                height='51'
                                )
                                path(d='M24.43 51.33H4.65a4.47 4.47 0 0 1-4.46-4.47V4.65A4.46 4.46 0 0 1 4.65.19h19.78a4.47 4.47 0 0 1 4.47 4.46v42.21a4.47 4.47 0 0 1-4.47 4.47zM4.65 2A2.71 2.71 0 0 0 2 4.65v42.21a2.71 2.71 0 0 0 2.7 2.7h19.73a2.7 2.7 0 0 0 2.7-2.7V4.65A2.71 2.71 0 0 0 24.43 2z')
                                path(d='M1.07 40.01h26.94v1.76H1.07zM1.07 8.75h26.94v1.76H1.07z')
                                rect(x='11.69', y='4.84', width='5.71', height='1.76', rx='.88')
                                path(d='M14.54 48.94a3.21 3.21 0 1 1 3.21-3.21 3.21 3.21 0 0 1-3.21 3.21zm0-4.65A1.45 1.45 0 1 0 16 45.73a1.45 1.45 0 0 0-1.46-1.44z')

                        .googlemap-infobox__data
                            h4.googlemap-infobox__title(
                                v-html='infoboxValue.title'
                                )
                            p.googlemap-infobox__value(
                                v-html='infoboxValue.value.toLocaleString("ru-RU")'
                                )

        .googlemap__notes(
            :class='{"googlemap__notes--show": infoboxName !== ""}'
            )
            p(
                v-for='(note, index) in notes',
                :key='index',
                v-html='note'
                )

        .googlemap__share(v-if="share")
            share(:url="share.shareUrl", :title="share.title", :description="share.description")

</template>

<script>
import Share from '@/components/Share.vue';
import GoogleMapsLoader from 'google-maps';
/* import MarkerClusterer from '@google/markerclusterer'; */

const isProd = process.env.NODE_ENV === 'production';
const meta = require('@/assets/data/meta.json');
const projectPath = meta.url.indexOf('https://dyn.ig.rambler.ru') !== -1 ? meta.url.replace('https://dyn.ig.rambler.ru', '') : '/';
const publicPath = isProd ? projectPath : '/';

export default {
    name: 'GoogleMap',

    props: {
        title: {
            type: String,
            require: true
        },
        share: {
            type: Object,
            default: null
        }
    },

    components: {
        Share
    },

    data() {
        return {
            regionsData: [],
            errors: [],
            googleObject: undefined,
            mapObject: undefined,
            markerCluster: undefined,
            markersArray: [],
            infoboxName: '',
            infobox: {
                cost: {
                    title: 'Месячная стоимость, руб.',
                    value: undefined
                },
                porsche: {
                    title: 'Месячная стоимость в&nbsp;Porsche&nbsp;Panamera<sup>*</sup>',
                    value: undefined
                },
                iphone: {
                    title: 'Месячная стоимость в&nbsp;iPhone<sup>**</sup>',
                    value: undefined
                }
            },
            notes: [
                '<sup>*</sup> Из&nbsp;расчёта 15&nbsp;млн&nbsp;рублей за&nbsp;Porsche Panamera в&nbsp;максимальной комплектации',
                '<sup>**</sup> Из&nbsp;расчета 80 тысяч рублей за&nbsp;IPhone Xs&nbsp;MAX 64gb'
            ]
        };
    },

    /* watch: {
        mapSwitch(value) {
            if (value === 'cities') {
                if (this.markersArray.length > 0) {
                    this.showMarkers();
                } else {
                    this.paintMarkers();
                }
            } else {
                this.hideMarkers();

                this.paintRegions();
            }
        }
    }, */

    created() {
        this.fetchData();
    },

    mounted() {
        this.generateMap();
    },

    beforeDestroy() {
        this.cleanMap();
    },

    methods: {
        async fetchData() {
            try {
                /* const responseCities = await fetch(publicPath + 'assets/data/googlemap_cities.json'); */
                const responseRegions = await fetch(publicPath + 'assets/data/googlemap_regions.json');

                /* this.citiesData = await responseCities.json(); */
                this.regionsData = await responseRegions.json();
            } catch (e) {
                this.errors.push(e);
            }
        },

        generateMap() {
            GoogleMapsLoader.KEY = 'AIzaSyBinoOja-ZMVeQ9mt_SBmZBAj5RBvEL7tQ';
            GoogleMapsLoader.VERSION = 'weekly';
            GoogleMapsLoader.LANGUAGE = 'ru';
            GoogleMapsLoader.REGION = 'RU';

            GoogleMapsLoader.load(google => {
                this.googleObject = google;

                this.mapObject = new this.googleObject.maps.Map(this.$refs.mapContainer, {
                    zoom: 4,

                    center: {
                        lat: 55.755871,
                        lng: 37.61768
                    },

                    mapTypeControlOptions: {
                        mapTypeIds: []
                    },

                    fullscreenControl: false,

                    styles: [
                        {
                            featureType: 'water',
                            stylers: [
                                {
                                    color: '#030B1F'
                                }
                            ]
                        },
                        {
                            featureType: 'landscape',
                            stylers: [
                                {
                                    color: '#001E35'
                                }
                            ]
                        },
                        {
                            featureType: 'road',
                            stylers: [
                                {
                                    color: '#001E35'
                                }
                            ]
                        },
                        {
                            featureType: 'poi.park',
                            stylers: [
                                {
                                    color: '#001E35'
                                }
                            ]
                        },
                        {
                            featureType: 'transit',
                            stylers: [
                                {
                                    color: '#004a5b'
                                },
                                {
                                    visibility: 'simplified'
                                }
                            ]
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.icon',
                            stylers: [
                                {
                                    color: '#01FFF0'
                                },
                                {
                                    visibility: 'off'
                                }
                            ]
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.text.stroke',
                            stylers: [
                                {
                                    color: '#001E35'
                                },
                                {
                                    visibility: 'off'
                                }
                            ]
                        },
                        {
                            featureType: 'transit',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#004a5b'
                                },
                                {
                                    visibility: 'off'
                                }
                            ]
                        },
                        {
                            featureType: 'road',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#004a5b'
                                }
                            ]
                        },
                        {
                            featureType: 'administrative',
                            elementType: 'labels',
                            stylers: [
                                {
                                    visibility: 'simplified'
                                },
                                {
                                    color: '#01FFF0'
                                }
                            ]
                        },
                        {
                            featureType: 'poi',
                            stylers: [
                                {
                                    color: '#01FFF0'
                                },
                                {
                                    visibility: 'off'
                                }
                            ]
                        }
                    ]
                });

                this.paintRegions();
            });
        },

        cleanMap() {
            GoogleMapsLoader.release();
        },

        /* generateMarkers() {
            const markerIcons = [
                {
                    url: publicPath + 'assets/img/googlemap/marker-pin.png',
                    size: new this.googleObject.maps.Size(19, 28),
                    origin: new this.googleObject.maps.Point(0, 0),
                    anchor: new this.googleObject.maps.Point(9, 30),
                    scaledSize: new this.googleObject.maps.Size(19, 28)
                }
            ];

            const infowindow = new this.googleObject.maps.InfoWindow();

            if (this.citiesData.length > 0) {
                this.citiesData.forEach(({latitude, longitude, city, population}) => {
                    const marker = new this.googleObject.maps.Marker({
                        position: {
                            lat: latitude,
                            lng: longitude
                        },
                        title: city,
                        icon: markerIcons[0]
                    });

                    marker.addListener('click', function() {
                        infowindow.close();
                        infowindow.setContent(
                            `<div class="infowindow" style="color:#030B1F;"><b>${city}</b><br>Население: ${population.toLocaleString("ru-RU")}</div>`
                        );
                        infowindow.open(this.mapObject, marker);
                    });

                    this.markersArray.push(marker);
                });

                this.showMarkers();
            }
        }, */

        /* showMarkers() {
            this.markerCluster = new MarkerClusterer(this.mapObject, this.markersArray, {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
            });
        }, */

        /* hideMarkers() {
            this.markerCluster.clearMarkers();
        }, */

        paintRegions() {
            this.$Progress.start();

            this.mapObject.data.setStyle({
                strokeWeight: 0.1,
                strokeColor: '#01fff0',
                fillColor: '#fff',
                fillOpacity: 0.1,
                visible: true
            });

            this.mapObject.data.loadGeoJson(publicPath + 'assets/data/googlemap_borders.geojson', {}, () => {
                this.$Progress.finish();
            });

            this.mapObject.data.addListener('mouseover', e => {
                this.mapObject.data.revertStyle();
                this.mapObject.data.overrideStyle(e.feature, {
                    strokeWeight: 1
                });
            });
            this.mapObject.data.addListener('mouseout', () => {
                this.mapObject.data.revertStyle();
            });

            this.mapObject.data.addListener('click', e => {
                const feature = e.feature;

                this.mapObject.data.overrideStyle(feature, {
                    fillOpacity: 0.3
                });

                this.infoboxName = '';

                const arrayIndex = this.regionsData.findIndex(region => region.name === feature.h['name:ru'] || region.name === feature.h['official_name:ru']);
                if (arrayIndex !== -1) {
                    const {name, cost, porsche, iphone} = this.regionsData[arrayIndex];

                    this.infoboxName = name;
                    this.infobox.cost.value = cost;
                    this.infobox.porsche.value = porsche;
                    this.infobox.iphone.value = iphone;
                }
            });
        },

        clickCloseInfobox() {
            this.infoboxName = '';
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars';

.googlemap {
    position: relative;
    width: 75%;
    margin: 0 auto var(--width-column-grid);
    padding: 0;
    box-sizing: border-box;

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        width: 100%;
    }

    &__title {
        display: flex;
        justify-content: center;
        margin: 0 auto 1em;
        font-family: var(--font-accent);
        text-align: center;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-bottom: 0.5em;
        }

        span {
            padding: 0.5em;
            background-color: rgba(#01fff0, 0.15);
            color: var(--color-accent);
        }
    }

    &__share {
        color: var(--color-header);
        display: flex;
        justify-content: center;
        padding-top: 0;
        margin-bottom: -1em;

        .share__item {
            transform: translateY(10%);
        }
    }

    &__desc {
        margin: 0 0 1em;
        font-size: 0.7em;
        line-height: 1.1;
        text-align: center;
    }

    /* &-switch {
        position: relative;
        display: flex;
        margin: 0 0 1em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-left: var(--scr-padding-side);
            margin-bottom: 0.5em;
        }

        &__radio {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;

            &:checked + label {
                background: #f8dd00;
                color: #000;
            }
        }

        &__label {
            margin: 0 1em 0 0;
            padding: 0.2em 1em 0.2em 0.5em;
            border: 1px solid #f8dd00;
            color: #f8dd00;
            cursor: pointer;

            &::before {
                content: '-> ';
            }
        }
    } */

    &__wrapper {
        position: relative;
    }

    &__container {
        height: 50vh;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            height: 75vh;
        }
    }

    &-infobox {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 25%;
        max-height: 50vh;
        margin: 0;
        background: rgba(12, 18, 34, 0.9);

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            max-height: 75vh;
        }

        @media (--viewport-tablet-pt) {
            width: 50%;
        }

        @media (--viewport-mobile) {
            width: 75%;
        }

        &__close {
            position: absolute;
            top: calc(var(--scr-padding-side) / 2);
            right: calc(var(--scr-padding-side) / 2);
            width: 1em;
            height: 1em;

            svg {
                width: 100%;
                height: 100%;
                vertical-align: top;
            }
        }

        &__name {
            margin: calc(var(--scr-padding-side) / 2) var(--scr-padding-side) 0 calc(var(--scr-padding-side) / 2);
            padding: 0;
            line-height: 1.1;
        }

        &__empty {
            margin: 0;
            padding: var(--scr-padding-top) calc(var(--scr-padding-side) / 2);
            font-size: 0.7em;
            color: #efdb34;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                padding: calc(var(--scr-padding-side) / 2);
            }
        }

        &__list {
            margin: 0;
        }

        &__item {
            display: flex;
            margin: 0;
            padding: var(--scr-padding-top) calc(var(--scr-padding-side) / 2);

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                padding: calc(var(--scr-padding-side) / 2);
            }

            &:not(:first-child) {
                border-top: 1px dashed #efdb34;
            }
        }

        &__icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 27%;
            margin: 0;
            color: var(--color-accent);
        }

        &__svg {
            fill: currentColor;
        }

        &__data {
            flex: 1;
            margin: 0;
            padding: 0 0 0 calc(var(--scr-padding-side) / 2);
        }

        &__title {
            margin: 0;
            font-size: 0.7em;
            line-height: 1.1;
            color: #efdb34;
        }

        &__value {
            margin: 0;
        }
    }

    &__notes {
        opacity: 0;
        margin: 1em 0 0;
        font-size: 0.7em;
        line-height: 1.1;
        color: #efdb34;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            padding: 0 var(--scr-padding-side);
        }

        &--show {
            opacity: 1;
        }

        p {
            &:not(:last-child) {
                margin-bottom: 0.5em;
            }
        }
    }
}
</style>
